import { render, staticRenderFns } from "./BrandLayout.vue?vue&type=template&id=06650fcf&"
import script from "./BrandLayout.vue?vue&type=script&lang=js&"
export * from "./BrandLayout.vue?vue&type=script&lang=js&"
import style0 from "./BrandLayout.vue?vue&type=style&index=0&id=06650fcf&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports